const en = {
  Signin: "Signin",
  Signup: "Signup",
  "Contact Us Preview": "Contact Us Preview",
  Logout: "Logout",
  Welcome: "Welcome",
  "Get Started": "Get Started",
  "Home Preview": "Home Preview",
  "About Us Preview": "About Us Preview",
  "Features Preview": "Features Preview",
  "Image Uploaded": "Image Uploaded",
  "Drag & Drop files or Browse": "Drag & Drop files or Browse",
  Preview: "Preview",
  Cancel: "Cancel",
  "Save Changes": "Save Changes",
  "Features that live up to your taste and enable you to work":
    "Features that live up to your taste and enable you to work",
  "With a few clicks, you will have launched your electronic identity in the Internet space, with an unprecedented quality that has been meticulously developed to meet the most important details.":
    "With a few clicks, you will have launched your electronic identity in the Internet space, with an unprecedented quality that has been meticulously developed to meet the most important details.",
  "Add Social Media": "Add Social Media",
  Add: "Add",
  "Add Home Link": "Add Home Link",
  "Add Quick Link": "Add Quick Link",
  "Upload Logo": "Upload Logo",
  Label: "Label",
  URL: "URL",
  "Quick Link Label": "Quick Link Label",
  "Home Link Label": "Home Link Label",
  "New Home Link": "New Home Link",
  "Link Label": "Link Label",
  "Link URL": "Link URL",
  Home: "Home",
  "Quick Links": "Quick Links",
  Address: "Address",
  "3041 Alasaker St an nuzha Riyadh": "3041 Alasaker St an nuzha Riyadh",

  Name: "Name",
  Email: "Email",
  Message: "Message",
  "Send Message": "Send Message",
  "Billed Monthly":"Billed Monthly",
  "Billed Yearly" :"Billed Yearly",
  "Monthly":"Monthly",
  "Yearly" :"Yearly",
  "Hosting Plans":"Hosting Plans",
  "SaaS Admin Signin":"SaaS Admin Signin",
  "Password":"Password",
  "Remember me" :"Remember me",
  "Enter your email":"Enter your email",
  "Enter your password":"Enter your password",
  "Log In":"Log In",
  "Please Fill all the fields":"Please Fill all the fields",
  "Heading is required.":"Heading is required.",
  "Theme has been updated successfully":"Theme has been updated successfully",
  "Plan has been updated successfully":"Plan has been updated successfully",
  
};
export default en;
